module.exports = "div.full-height-minus-search {\n  height: calc(100% - 4.375rem);\n  position: relative; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/views/market-view.component.scss
// module id = ./src/app/main/views/market-view.component.scss
// module chunks = main